import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import Indicator from "../Indicator";
import InputGlobal from "../InputGlobal";
import { validateEmail, simplyClick } from "../../helpers";
import ButtonGroup from "../ButtonGroup";
import LoaderEmail from "../LoaderEmail";
import {
  domains,
  bodyTypes,
  landingId,
  ERROR_EMAIL_ALREADY_REGISTERED,
} from "../../constants/constans";

import { useWizardAnswers } from "ui-components";
import skinnyIcon from "../../images/ico_skinny.svg";
import averageIcon from "../../images/ico_average.svg";
import modelIcon from "../../images/ico_model.svg";
import plusIcon from "../../images/ico_plus-size.svg";
import BigIcon from "../../images/ico_big.svg";
import dontCareIcon from "../../images/ico_question-mark.svg";
import Tooltip from "../Tooltip";

import "./Email.scss";

const Email = ({ step, setStep }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);
  const [loaderTextMain, setLoaderTextMain] = useState("");
  const [loaderTextSub, setLoaderTextSub] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);

  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [showLogin, setShowLogin] = useState(false);

  const handleSelectIndicator = (id) => {
    const selected = bodyTypes[id];

    if (!selected) return;

    setSelectedIndicator(selected.label);
    updateAnswer({ body_type: [String(id)] });

    if (selected.event) {
      simplyClick(selected.event);
    }
  };

  const updateAnswer = useWizardAnswers();
  const handlerSubmit = () => {
    if (!selectedIndicator) {
      updateAnswer({ body_type: ["0"] });
    }
    setLoader(true);
    setLoaderTextMain("Verifying your email.");
    setLoaderTextSub("This might take a moment.");

    const textTimeout = setTimeout(() => {
      setLoaderTextMain("Still verifying your email...");
      setLoaderTextSub("Thanks for your patience!");
    }, 3000);

    validateEmail(data.email, (result) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderTextMain("");
      setLoaderTextSub("");

      const { status, error } = result;

      if (!status) {
        if (error === ERROR_EMAIL_ALREADY_REGISTERED) {
          setShowLogin(true);
          setErrorEmail(error);
        } else if (!status) {
          setErrorEmail(error);
        }
        if (error === ERROR_EMAIL_ALREADY_REGISTERED) {
          setShowLogin(true);
          setErrorEmail(error);
        } else if (!status) {
          setErrorEmail(error);
        }
      } else {
        simplyClick("cl_lnd_afm3_email_next");
        setStep(step + 1);
      }
    });
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_afm3_email_back");
    setStep(step - 1);
  };

  const handleAddEmail = (e) => {
    setEmailValue(e.target.value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setShowLogin(false);
    setData({ ...data, email: value });
  };

  const setFullEmail = (fullEmail) => {
    setErrorEmail(null);
    setData({ ...data, email: fullEmail });
  };

  return (
    <>
      {loader && (
        <LoaderEmail textMain={loaderTextMain} textSub={loaderTextSub} />
      )}
      <div className="global__form-wrap">
        <div className="email__form">
          <h5 className="form__title">
            What body type do you find most attractive?
          </h5>
          <div className="group__top">
            <Indicator
              textLabel={bodyTypes[1].label}
              iconIndicator={skinnyIcon}
              className="component-1"
              isActive={selectedIndicator === bodyTypes[1].label}
              onClick={() => handleSelectIndicator(1)}
            />
            <Indicator
              textLabel={bodyTypes[2].label}
              iconIndicator={modelIcon}
              className="component-2"
              isActive={selectedIndicator === bodyTypes[2].label}
              onClick={() => handleSelectIndicator(2)}
            />
            <Indicator
              textLabel={bodyTypes[3].label}
              iconIndicator={averageIcon}
              className="component-3"
              isActive={selectedIndicator === bodyTypes[3].label}
              onClick={() => handleSelectIndicator(3)}
            />
          </div>
          <div className="group__bottom">
            <Indicator
              textLabel={bodyTypes[4].label}
              iconIndicator={plusIcon}
              className="component-4"
              isActive={selectedIndicator === bodyTypes[4].label}
              onClick={() => handleSelectIndicator(4)}
            />
            <Indicator
              textLabel={bodyTypes[5].label}
              iconIndicator={BigIcon}
              className="component-5"
              isActive={selectedIndicator === bodyTypes[5].label}
              onClick={() => handleSelectIndicator(5)}
            />
            <Indicator
              textLabel={bodyTypes[6].label}
              iconIndicator={dontCareIcon}
              className="component-6"
              isActive={selectedIndicator === bodyTypes[6].label}
              onClick={() => handleSelectIndicator(6)}
            />
          </div>
          <span className="line" />
          <h5 className="form__title">Enter your email to create an account</h5>
          <div className="email_input">
            <div className="has-float-label">
              <InputGlobal
                className={
                  "input__global" +
                  (errorEmail ? " error" : "") +
                  (data.email?.length > 0 && !data.email?.includes("@")
                    ? " active"
                    : "")
                }
                onChange={(e) => handleAddEmail(e)}
                name={"email__afm3"}
                placeholder={"Enter a valid email"}
                type={"text"}
                id={"email__afm3"}
                value={data.email ? data.email : ""}
                onFocus={() => {
                  if (!data.email) {
                    setShowTooltip(true);
                  }

                  simplyClick("cl_lnd_afm3_email_type_email");
                }}
                onBlur={() => setShowTooltip(false)}
              />
              <label
                htmlFor="email__afm3"
                className={errorEmail ? "error" : ""}
              >
                Enter a valid email
              </label>
              {data.email?.length > 0 && !data.email?.includes("@") && (
                <div
                  className={"autocomplete__box" + (errorEmail ? " error" : "")}
                >
                  <ul className="autocomplete__box-list">
                    {domains.map((domain, index) => (
                      <li
                        onClick={() => setFullEmail(data.email + domain)}
                        className="autocomplete__box-list-item"
                        key={index}
                      >
                        {data.email}
                        {domain}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {errorEmail && <p className="error-text">{errorEmail}</p>}
              <Tooltip
                text="We'll use this email for account verification and important notifications."
                showTooltip={showTooltip}
                className="email"
              />
              {showLogin && (
                <div className="email_login-wrap">
                  <a
                    href={`/login/?landing_id=${landingId}${data?.email
                      ? `&email=${encodeURIComponent(data.email)}`
                      : ""
                      }`}
                    id="log-in-email"
                    className="email__login"
                    onClick={() => simplyClick("cl_lnd_afm3_againemail_login")}
                  >
                    Log in
                  </a>{" "}
                  <p className="email_login-text"> or use another email.</p>
                </div>
              )}
            </div>
          </div>
        </div>
        <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
      </div>
    </>
  );
};
export default Email;
